import request from '@/utils/request';
export const renameResources = (data: any) =>
  request({
    url: 'Knowledge/renameResources',
    method: 'PUT',
    data
  });
export const addCollection = (data: any) =>
  request({
    url: 'Knowledge/collection',
    method: 'POST',
    data
  });
export const delCollection = (data: any) =>
  request({
    url: 'Knowledge/collection',
    method: 'DELETE',
    data
  });
export const getScource = (params: any) =>
  request({
    url: 'Knowledge/resources',
    method: 'get',
    params
  });
export const importScource = (data: any) =>
  request({
    url: 'Knowledge/resources',
    method: 'POST',
    data
  });

export const batchDeleteResources = (data: any) =>
  request({
    url: 'Knowledge/batchDeleteResources',
    method: 'DELETE',
    data
  });
export const delScource = (data: any) =>
  request({
    url: 'Knowledge/resources',
    method: 'DELETE',
    data
  });

export const batchReallyDelete = (data: any) =>
  request({
    url: 'Knowledge/batchReallyDelete',
    method: 'DELETE',
    data
  });
export const reallyDelete = (data: any) =>
  request({
    url: 'Knowledge/reallyDelete',
    method: 'DELETE',
    data
  });
export const addGroup = (data: any) =>
  request({
    url: 'Knowledge/group',
    method: 'POST',
    data
  });
export const addDocument = (data: any) =>
  request({
    url: 'Knowledge/document',
    method: 'POST',
    data
  });
export const editorDocument = (data: any) =>
  request({
    url: 'Knowledge/document',
    method: 'PUT',
    data
  });
export const delDocument = (data: any) =>
  request({
    url: 'Knowledge/document',
    method: 'DELETE',
    data
  });
export const getKnowledgeScourceList = (params: any) =>
  request({
    url: 'Knowledge/resourcesList',
    method: 'get',
    params
  });
export const getKnowledgeDraftsList = (params: any) =>
  request({
    url: 'Knowledge/draftsList',
    method: 'get',
    params
  });
export const getKnowledgeRecycleListList = (params: any) =>
  request({
    url: 'Knowledge/recycleList',
    method: 'get',
    params
  });
export const recover = (data: any) =>
  request({
    url: 'Knowledge/recover',
    method: 'PUT',
    data
  });
